import React, { useState, useEffect } from 'react'
import Sound from 'react-sound'

import menu from "../../../assets/audio/menu.mp3"

import Header from '../../Header'
import Footer from '../../Footer'
import LinkButton from '../../LinkButton'

function Layout(props){
  const [ music, setMusic ] = useState(false)

  function musicLoaded() {
    const musicSetting = JSON.parse(localStorage.getItem('musicSetting'))

    if(musicSetting === undefined){
      setMusic(true)
    } else {
      setMusic(musicSetting)
    }
  }

  function toggleMusic(){
    localStorage.setItem('musicSetting', JSON.stringify(!music))
    setMusic(!music)
  }

  return (
    <>
      <Sound
        url={ menu }
        playStatus={ music ? Sound.status.PLAYING : Sound.status.STOPPED }
        onLoad={() => musicLoaded()}
        volume={ 50 }
        autoLoad={ true }
        loop={ true }
      />
      <Header toggle={ () => toggleMusic() } music={ music }>
        <LinkButton selected={ false } link="/" text="BACK TO SITE"/>
        <LinkButton selected={ props.selected === 'challenges' ? true : false } link="/admin/challenges" text="UPDATE CHALLENGES"/>
        <LinkButton selected={ props.selected === 'pitstop' ? true : false } link="/admin/pitstop" text="UPDATE PIT STOP"/>
      </Header>
        { props.children }
      <Footer/>
    </>
  )
}

export default Layout